// PropTypes
import PropTypes from 'prop-types'
// import Select from 'react-select'

export default function RamStatusCheck({ users, values }) {
  const blockStyle =
    'grid items-center grid-cols-12 p-3 lg:auto-rows-min print:p-1.5 md:gap-y-1 lg:gap-y-3 print:gap-y-1 print:auto-rows-auto'
  const innerBlockStyle =
    'grid items-center grid-cols-12 col-span-6 p-3 auto-rows-min grow divide-dashed print:p-1.5 md:gap-y-1 lg:gap-y-3 print:gap-y-2'
  const firstLabelStyles =
    'col-span-12 text-sm print:col-span-3 lg:col-span-4 xl:col-span-3 font-ms-semi'
  const otherLabelsStyles =
    'col-span-12 mt-5 text-sm lg:mt-5 xl:mt-0 lg:col-span-4 xl:col-span-3 font-ms-semi print:mt-0'
  const firstParentStyles =
    'flex items-center col-span-12 space-x-2 cursor-not-allowed min-h-8 print:h-full print:col-span-9 lg:col-span-8 xl:col-span-9'
  const otherParentStyles =
    'flex items-center col-span-12 mt-0 space-x-2 cursor-not-allowed lg:mt-5 xl:mt-0 print:mt-0 min-h-8 lg:col-span-8 xl:col-span-9'
  const innerParentStyles =
    'w-full p-0.5 print:p-0 print:h-full leading-tight print:leading-none text-base border-b border-gray-300 overflow-ellipsis overflow-hidden flex items-center place-self-end'
  const checkStyles = 'border border-gray-800 ft-check'

  return (
    <div className={`${blockStyle}`}>
      {/* COMPROVAR FILTRES / FULARD / CORRONS */}
      <div className={`${otherLabelsStyles} print:col-span-5`}>
        Comprovar filtres / fulard / corrons:
      </div>
      <div
        className={`${otherParentStyles} justify-end print:col-span-1 print:h-full print:pr-1.5 print:border-r print:border-dashed print:border-blue-1`}
      >
        <div className={checkStyles}></div>
      </div>

      {/* COMPROVAR DRAP TOBERES / DRAP GOMES / ENCOLADORS / MAQ. COSIR / AGULLES RAM / V.A. */}
      <div className={`${otherLabelsStyles} print:col-span-5 print:pl-1.5`}>
        Comprovar drap toberes / drap gomes / encoladors / maq. Cosir / agulles ram / V.A.:
      </div>
      <div
        className={`${otherParentStyles} justify-end print:col-span-1 print:h-full`}
      >
        <div className={checkStyles}></div>
      </div>

      {/* OBSERVACIONS */}
      <div className={`${otherLabelsStyles} print:col-span-2`}>
        Observacions:
      </div>
      <div className={`${otherParentStyles} print:col-span-10 print:h-24`}>
        <div className={innerParentStyles}>
          {values?.RamStatusCheckObservation}
        </div>
      </div>
    </div>
  )
}

RamStatusCheck.propTypes = {
  users: PropTypes.array,
  values: PropTypes.object
}
